import { Link } from "react-router-dom";
import { ChevronUp } from "lucide-react";
import config from "../config";
import { assetPath } from "../utils/assets";

const FloatingButtons = () => {
    const handleScrollTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className="bg-primary">
            <button
                onClick={handleScrollTop}
                className="fixed bottom-16 left-4 container-equal-lg btn-gradient hover-opacity-70 animate-ease rounded-full lg:bottom-6"
                style={{ zIndex: 1000 }}
            >
                <ChevronUp className="size-sm" />
            </button>

            <Link
                to={config.TELEGRAM_URL}
                target="_blank"
                className="fixed bottom-16 right-4 container-equal-lg shadow-[0px_-2px_0px_0px_#22CF02_inset] bg-[linear-gradient(124.12deg,_#39FF14_6.47%,_#22990C_91.98%)] hover:bg-[linear-gradient(124.12deg,_#DCFFD5_6.47%,_#47FF25_91.98%)] hover-opacity-70 animate-ease rounded-full gap-2 lg:bottom-6"
                style={{ zIndex: 1000 }}
            >
                <p className="font-bold font-sm">
                    24/7
                </p>
                <img 
                    src={assetPath("/icons/live_chat_2.png")}
                    className="size-sm" 
                    alt="Live Chat" 
                />
            </Link>
        </div>
    );
};

export default FloatingButtons;